// /:elemental_url/:id/duplicate

import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { duplicateElemental } from '~~/src/api/elementals'
import { ElementalTypeEnum } from '~~/src/types/elemental'

export const useDuplicateElemental = () => {
  const queryClient = useQueryClient()
  return useMutation<
    Awaited<ReturnType<typeof duplicateElemental>>,
    Error,
    {
      elementalType: ElementalTypeEnum
      elementalId: string
      listId?: string
    }
  >({
    mutationKey: ['duplicate-elemental'],
    mutationFn: async ({ elementalId, listId }) => {
      const validListid = listId
      return await duplicateElemental(elementalId, validListid)
    },
    onError: (_, { elementalType }) => {
      queryClient.refetchQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
    },
    onSuccess: (result, { elementalType, listId }) => {
      if (elementalType === ElementalTypeEnum.List && result) {
        queryClient.invalidateQueries({
          queryKey: ['profile-list-elementals', result?.elementalTypeId],
          exact: false,
          type: 'all',
        })

        queryClient.refetchQueries({
          queryKey: ['profile-list-elementals', result?.elementalTypeId],
          exact: false,
          type: 'all',
        })
      }
      if (listId) {
        queryClient.invalidateQueries({
          queryKey: ['list-elementals', listId],
          exact: false,
          type: 'all',
        })
        queryClient.refetchQueries({
          queryKey: ['list-elementals', listId],
          exact: false,
          type: 'all',
        })
        return
      }
      queryClient.invalidateQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
      queryClient.refetchQueries({
        queryKey: ['profile-list-elementals', elementalType],
        exact: false,
        type: 'all',
      })
    },
  })
}
